<template>
  <el-card shadow="hover" class="form-card" :class="'form-card--' + (form.state || 'pending')" @click.native="onOpen">
    <div class="form-card__num">{{ form.num }}</div>
    <div class="form-card__title">{{ form.title }}</div>
    <el-tag size="mini" :type="tagType">{{ form.stateLabel || '未开始' }}</el-tag>
    <div v-if="form.viewOnly" class="form-card__view-only">仅查看</div>
    <div v-if="form.phase" class="form-card__phase text-muted">{{ phaseLabel }}</div>
  </el-card>
</template>

<script>
const PHASE_LABELS = {
  dispatch: '派遣',
  sampling: '现场',
  handover: '交接',
  lab: '理化',
  other: '其他'
}

export default {
  name: 'ProjectFormCard',
  props: {
    form: { type: Object, required: true }
  },
  computed: {
    tagType() {
      const s = this.form && this.form.state
      if (s === 'done') return 'success'
      if (s === 'pending_audit') return 'warning'
      if (s === 'doing') return ''
      return 'info'
    },
    phaseLabel() {
      return PHASE_LABELS[this.form.phase] || this.form.phase || ''
    }
  },
  methods: {
    onOpen() {
      this.$emit('open', this.form)
    }
  }
}
</script>

<style scoped>
.form-card {
  cursor: pointer;
  min-height: 118px;
  margin-bottom: 12px;
}
.form-card__num {
  font-size: 20px;
  font-weight: 700;
  color: #409eff;
}
.form-card__title {
  font-size: 13px;
  color: #303133;
  margin: 8px 0;
  min-height: 36px;
  line-height: 1.35;
}
.form-card__phase {
  font-size: 12px;
  margin-top: 6px;
}
.form-card__view-only {
  font-size: 11px;
  color: #909399;
  margin-top: 4px;
}
.text-muted { color: #909399; }
</style>
